import { render, staticRenderFns } from "./ProcedimentoRegiao.vue?vue&type=template&id=cb8e57ce&"
import script from "./ProcedimentoRegiao.vue?vue&type=script&lang=js&"
export * from "./ProcedimentoRegiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports